export const setSessionStorageToken = (
  sessionStorageKey: string,
  sessionStorageToken: any
) => {
  sessionStorage.setItem(sessionStorageKey, JSON.stringify(sessionStorageToken))
}

export const getSessionStorageToken = (
  sessionStorageKey: string
): string | null => {
  return sessionStorage.getItem(sessionStorageKey)
}
